export var AnalyticsProviders = /*#__PURE__*/ function(AnalyticsProviders) {
    AnalyticsProviders["DATADOG"] = "DATADOG";
    AnalyticsProviders["MIXPANEL"] = "MIXPANEL";
    return AnalyticsProviders;
}({});
/**
 * Takes n number of providers and executes the calls on each
 * as if it is a single provider.
 */ export const analyticsFactory = (providers)=>{
    const analyticsProviders = providers;
    return {
        initialize: (config)=>{
            analyticsProviders.forEach((provider)=>{
                provider.initialize(config);
            });
        },
        handleAction: (action, data)=>{
            analyticsProviders.forEach((provider)=>{
                provider.handleAction(action, data);
            });
        },
        handleLocationChange: (location)=>{
            analyticsProviders.forEach((provider)=>{
                provider.handleLocationChange(location);
            });
        },
        reset: ()=>{
            analyticsProviders.forEach((provider)=>{
                provider.reset();
            });
        },
        setServiceLine: (serviceLine)=>{
            analyticsProviders.forEach((provider)=>{
                provider.setServiceLine(serviceLine);
            });
        },
        setContext: (context)=>{
            analyticsProviders.forEach((provider)=>{
                provider.setContext(context);
            });
        },
        setUser: (user)=>{
            analyticsProviders.forEach((provider)=>{
                provider.setUser(user);
            });
        },
        trackView: (viewName)=>{
            analyticsProviders.forEach((provider)=>{
                provider.trackView(viewName);
            });
        },
        trackAction: (action, data)=>{
            analyticsProviders.forEach((provider)=>{
                provider.trackAction(action, data);
            });
        }
    };
};
